/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Dialog, DialogContent } from '@material-ui/core';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  compareTwoDates,
  setDateFormatter,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  convertQuaterFromDate,
  convertQuaterToDate,
  convertFromDateToMMDDYYYY,
  convertToDateToMMDDYYYY,
  getCommonDropdownList,
  handleScrollToEvent,
  checkQuarterValidation,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CheckTable from './CheckTable';
// import createIcon from "../../../../assets/images/feather-settings.svg";
import * as ErrorMessage from './errorMessage';
import {
  getSearchCheckResults,
  getAllLastUserId,
  getgeneralsystemparameterDetails,
  searchCheckReqAction,
  checkSearchFormErrorAction,
  checkSearchErrorMessageAction,
  maintainCheckReqAction,
  maintainCheckFormErrorAction,
  maintainCheckErrorMessageAction,
  dispatchSaveCheckValues,
} from '../store/actions';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { setDisplayCheckTableData } from '../../../Display/Check/store/action';
import * as ConstantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import {
  autoFormateDate,
  PaperComponent,
} from '../../../../SharedModules/utilities/utilities';
import { validateDateQuarter } from '../../../../SharedModules/utilities/dateUtilities';

/**
 * Check Search Component helps user to search the check based on different criteria such as Check log,
 * check Number, CCN etc.
 * @Date 10-OCT-2022
 * @author Nazia Rizwan
 */

const CheckSearch = (props) => {
  const [showTable, setShowTable] = React.useState(false);
  const dispatch = useDispatch();

  const getAllSearchCheckResults = (value) =>
    dispatch(getSearchCheckResults(value));
  const getFetchAllLastUsers = () => dispatch(getAllLastUserId());
  const checkSearchRequest = useSelector(
    (state) => state?.sharedState?.CheckReducer?.checkSearchRequestData
  );
  const checkSearchFormError = useSelector(
    (state) => state?.sharedState?.CheckReducer?.checkSearchFormErrorData
  );
  const checkSearchErrorMessage = useSelector(
    (state) => state?.sharedState?.CheckReducer?.checkSearchErrorMessage
  );
  const searchCheckFromDisplay = useSelector(
    (state) => state?.sharedState?.displayCheck?.searchCheckFromDisplay
  );

  const checkSearchResults = useSelector((state) => {
    return state.sharedState.CheckReducer.checkSearchResults;
  });
  const getAllLastUserIds = useSelector((state) => {
    return state.sharedState.CheckReducer.getAllLastUserIds;
  });
  const searchgeneralsystemparameterDetail = (value) =>
    dispatch(getgeneralsystemparameterDetails(value));

  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const payload = useSelector(
    (state) =>
      state?.sharedState?.CheckReducer?.generalSystemParameter?.paramGeneralVO
  );
  const [loading, setLoading] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [values, setValues] = useState({
    checkLogNum: '',
    checkNum: '',
    batchNum: '',
    disputeResolution: '-1',
    usedDrugRebate: '1',
    cnnNum: '',
    checkPayee: '-1',
    LoggedUser: '-1',
    checkIssuer: '',
    informationTxt: '',
    paymentType: '-1',
    invoiceReconcilication: '-1',
    checkFromDate: '',
    checkToDate: '',
    receivedFromDate: '',
    receivedToDate: '',
    suspendedFromDate: '',
    suspendedToDate: '',
    batchFromDate: '',
    batchToDate: '',
    postFromDate: '',
    postToDate: '',
  });
  const [formErrors, setFormsError] = useState({
    checkFromDate: false,
    checkGreaterDate: false,
    checkToDate: false,
    receivedFromDate: false,
    receivedGreaterDate: false,
    receivedToDate: false,
    suspendedFromDate: false,
    suspendedGreaterDate: false,
    suspendedToDate: false,
    batchFromDate: false,
    batchGreaterDate: false,
    batchToDate: false,
    postFromDate: false,
    postGreaterDate: false,
    postToDate: false,
  });
  const [errorMessages, setErrorMessages] = useState([]);
  const [userIdValueList, setUserIdValueList] = useState([]);
  const usedInDrug = [
    { name: 'Yes', id: 1, value: 1 },
    { name: 'No', id: 2, value: 0 },
    { name: 'N/A', id: 3, value: 2 },
  ];
  const [onSeachState, setOnSearch] = React.useState(false);
  const [searchCheckListResults, setSearchCheckResults] = useState([]);
  const [disableCCN, setDisableCCN] = useState(true);
  const [disableBatch, setDisableBatch] = useState(true);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [checkPayeeChanged, setCheckPayeeChanged] = useState(false);
  const [commonDropdownList, setCommonDropdownList] = useState({});
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const handleOnChangeEvent = (e, name) => {
    const regexNumber = /^[0-9]+$/;
    if (
      name === 'checkLogNum' &&
      (regexNumber.test(e.target.value) ||
        e.target.value.length > 38 ||
        e.target.value === '')
    ) {
      setValues({ ...values, [name]: e.target.value });
      const data = {
        ...checkSearchRequest,
        [name]: e.target.value,
      };
      dispatch(searchCheckReqAction(data));
    } else if (name !== 'checkLogNum') {
      setValues({ ...values, [name]: e.target.value });
      if (name === 'checkPayee') setCheckPayeeChanged(true);
      const data = {
        ...checkSearchRequest,
        [name]: e.target.value,
      };
      dispatch(searchCheckReqAction(data));
    }

    if (errorMessages.length > 0) {
      const errorMsg = [];
      setErrorMessages(errorMsg);
      dispatch(checkSearchErrorMessageAction(errorMsg));
    }
  };
  // On changing the Dates, this function will be called and set the values accordingly
  const handleChangeDate = (event, name) => {
    const date = event.target.value;
    setValues({ ...values, [name]: date?.toUpperCase() });
    if (name === 'checkFromDate' || name === 'checkToDate') {
      setFormsError({ ...formErrors, [name]: false, checkGreaterDate: false });
    } else if (name === 'receivedFromDate' || name === 'receivedToDate') {
      setFormsError({
        ...formErrors,
        [name]: false,
        receivedGreaterDate: false,
      });
    } else if (name === 'suspendedFromDate' || name === 'suspendedToDate') {
      setFormsError({
        ...formErrors,
        [name]: false,
        suspendedGreaterDate: false,
      });
    } else if (name === 'postFromDate' || name === 'postToDate') {
      setFormsError({ ...formErrors, [name]: false, postGreaterDate: false });
    } else if (name === 'batchFromDate' || name === 'batchToDate') {
      setFormsError({ ...formErrors, [name]: false, batchGreaterDate: false });
    }
    const data = {
      ...checkSearchRequest,
      [name]: event.target.value,
    };
    dispatch(searchCheckReqAction(data));
  };

  // On Bluring on the fields of the Dates, this function will be called and set the values accordingly
  // if the format is not correct, error message will be displayed
  const handleBlurDate = (event, name) => {
    const dateFromPicker = event?.target?.value?.toUpperCase();
    const regexNumber = /^[0-9/]+$/;
    let errorMsg = false;
    if (dateFromPicker?.includes('Q') || dateFromPicker?.includes('q')) {
      const dateUpperCase = autoFormateDate(dateFromPicker.toUpperCase());
      const splitYear = dateUpperCase.split('Q');
      const checkQuater = splitYear[0] <= 4;
      if (checkQuater && checkQuarterValidation(dateUpperCase)) {
        if (
          dateUpperCase.length === 6 &&
          regexNumber.test(splitYear[1]) &&
          splitYear[1] >= 1991 &&
          splitYear[1] <= 9999
        ) {
          if (name === 'checkFromDate') {
            const toDate =
              values.checkToDate === '' ? dateFromPicker : values.checkToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              checkToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                checkToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'checkToDate') {
            const toDate =
              values.checkToDate === '' ? dateFromPicker : values.checkToDate;

            setValues({
              ...values,
              checkToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                checkToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          }
          if (name === 'receivedToDate') {
            const toDate =
              values.receivedToDate === ''
                ? dateFromPicker
                : values.receivedToDate;
            setValues({
              ...values,
              receivedToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                receivedToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'suspendedToDate') {
            const toDate =
              values.suspendedToDate === ''
                ? dateFromPicker
                : values.suspendedToDate;
            setValues({
              ...values,
              suspendedToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                suspendedToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'batchToDate') {
            const toDate =
              values.batchToDate === '' ? dateFromPicker : values.batchToDate;
            setValues({
              ...values,
              batchToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                batchFromDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'postToDate') {
            const toDate =
              values.postToDate === '' ? dateFromPicker : values.postToDate;
            setValues({
              ...values,
              postToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                postToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'checkToDate') {
            const toDate =
              values.checkToDate === '' ? dateFromPicker : values.checkToDate;
            setValues({
              ...values,
              checkToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                checkToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'receivedFromDate') {
            const toDate =
              values.receivedToDate === ''
                ? dateFromPicker
                : values.receivedToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              receivedToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                receivedToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'suspendedFromDate') {
            const toDate =
              values.suspendedToDate === ''
                ? dateFromPicker
                : values.suspendedToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              suspendedToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                suspendedToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'batchFromDate') {
            const toDate =
              values.batchToDate === '' ? dateFromPicker : values.batchToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              batchToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                batchToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'postFromDate') {
            const toDate =
              values.postToDate === '' ? dateFromPicker : values.postToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              postToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                postToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          }
        } else if (
          dateFromPicker.length === 4 &&
          regexNumber.test(splitYear[1])
        ) {
          if (name === 'checkFromDate') {
            const toDate =
              values.checkToDate === '' ? dateFromPicker : values.checkToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              checkToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                checkToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'receivedFromDate') {
            const toDate =
              values.receivedToDate === ''
                ? dateFromPicker
                : values.receivedToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              receivedToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                receivedToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'suspendedFromDate') {
            const toDate =
              values.suspendedToDate === ''
                ? dateFromPicker
                : values.suspendedToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              suspendedToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                suspendedToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'batchFromDate') {
            const toDate =
              values.batchToDate === '' ? dateFromPicker : values.batchToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              batchToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                batchToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          } else if (name === 'postFromDate') {
            const toDate =
              values.postToDate === '' ? dateFromPicker : values.postToDate;
            setValues({
              ...values,
              [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
              postToDate: autoFormateDate(toDate?.toUpperCase()),
            });
            dispatch(
              searchCheckReqAction({
                ...checkSearchRequest,
                [name]: autoFormateDate(dateFromPicker?.toUpperCase()),
                postToDate: autoFormateDate(toDate?.toUpperCase()),
              })
            );
          }
        } else {
          formErrors[name] = true;
        }
      } else {
        formErrors[name] = true;
      }
    } else if (
      regexNumber?.test(dateFromPicker) &&
      dateFromPicker?.length > 0
    ) {
         // Handle 2-digit year conversion before calling autoFormateDate
      let dateToFormat = dateFromPicker;
      if (dateFromPicker.includes('/')) {
        const parts = dateFromPicker.split('/');
        if (parts.length === 3 && parts[2].length === 2) {
          const twoDigitYear = parseInt(parts[2], 10);
          const fourDigitYear = twoDigitYear < 100 ? 2000 + twoDigitYear : twoDigitYear;
          dateToFormat = `${parts[0]}/${parts[1]}/${fourDigitYear}`;
        }
      }
      const dateValue = autoFormateDate(dateFromPicker);
      if (validateDateQuarter(dateValue, name)?.length > 0) {
        formErrors[name] = true;
        errorMsg = true;
      } else {
        errorMsg = false;
        formErrors[name] = false;
      }
      
      const data = {
        ...checkSearchRequest,
        [name]: dateValue,
      };
      dispatch(searchCheckReqAction(data));
      
      if (name === 'checkFromDate') {
        const toDate =
          values.checkToDate === '' && !errorMsg
            ? dateValue
            : values.checkToDate;
        setValues({
          ...values,
          [name]: dateValue,
          checkToDate: toDate,
        });
      } else if (name === 'receivedFromDate') {
        const toDate =
          values.receivedToDate === '' && !errorMsg
            ? dateValue
            : values.receivedToDate;
        setValues({
          ...values,
          [name]: dateValue,
          receivedToDate: toDate,
        });
        
        if (values.receivedToDate === '' && !errorMsg) {
          dispatch(
            searchCheckReqAction({
              ...checkSearchRequest,
              [name]: dateValue,
              receivedToDate: dateValue,
            })
          );
        }
      } else if (name === 'suspendedFromDate') {
        const toDate =
          values.suspendedToDate === '' && !errorMsg
            ? dateValue
            : values.suspendedToDate;
        setValues({
          ...values,
          [name]: dateValue,
          suspendedToDate: toDate,
        });
        if (values.suspendedToDate === '' && !errorMsg) {
          dispatch(
            searchCheckReqAction({
              ...checkSearchRequest,
              [name]: dateValue,
              suspendedToDate: dateValue,
            })
          );
        }
      } else if (name === 'batchFromDate') {
        const toDate =
          values.batchToDate === '' && !errorMsg
            ? dateValue
            : values.batchToDate;
        setValues({
          ...values,
          [name]: dateValue,
          batchToDate: toDate,
        });
        if (values.batchToDate === '' && !errorMsg) {
          dispatch(
            searchCheckReqAction({
              ...checkSearchRequest,
              [name]: dateValue,
              batchToDate: dateValue,
            })
          );
        }
      } else if (name === 'postFromDate') {
        const toDate =
          values.postToDate === '' && !errorMsg ? dateValue : values.postToDate;
        setValues({
          ...values,
          [name]: dateValue,
          postToDate: toDate,
        });
        if (values.postToDate === '' && !errorMsg) {
          dispatch(
            searchCheckReqAction({
              ...checkSearchRequest,
              [name]: dateValue,
              postToDate: dateValue,
            })
          );
        }
      } else {
        setValues({
          ...values,
          [name]: dateValue,
        });
      }
    } else if (dateFromPicker === '') {
      formErrors[name] = false;
    } else formErrors[name] = true;
    setFormsError({ ...formErrors, [name]: formErrors[name] });
    if (formErrors[name]) {
      window.scroll(0, 0);
    }
    const data = {
      ...checkSearchFormError,
      [name]: formErrors[name],
    };
    dispatch(checkSearchFormErrorAction(data));
    isValidation('onBlur', name, formErrors[name]);
  };

  // On clicking on Search, this function will perform all the validations
  // if no error, then only searchCheck service call will be made.
  const isValidation = (type = '', formValue = '', formError = false) => {
    const errorDisplay = [];
    const formErr = {};
    let data = {};
    if (formValue !== '') {
      formErr[formValue] = formError;
      data = {
        ...checkSearchFormError,
        formValue: formError,
      };
    }
    if (
      values.checkLogNum === '' &&
      values.checkNum === '' &&
      values.batchNum === '' &&
      values.disputeResolution === '-1' &&
      values.cnnNum === '' &&
      values.LoggedUser === '-1' &&
      values.checkIssuer === '' &&
      values.informationTxt === '' &&
      values.paymentType === '-1' &&
      values.invoiceReconcilication === '-1' &&
      values.checkFromDate === '' &&
      values.checkToDate === '' &&
      values.receivedFromDate === '' &&
      values.receivedToDate === '' &&
      values.suspendedFromDate === '' &&
      values.suspendedToDate === '' &&
      values.batchFromDate === '' &&
      values.batchToDate === '' &&
      values.postFromDate === '' &&
      values.postToDate === '' &&
      type === 'Search'
    ) {
      errorDisplay.push(ErrorMessage.ATLEAST_ONE_SEARCH_FIELD);
      setShowTable(false);
    }
    if (formErrors.checkFromDate) {
      errorDisplay.push(
        `Check From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.checkToDate) {
      errorDisplay.push(
        `Check To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.receivedFromDate) {
      errorDisplay.push(
        `Received From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.receivedToDate) {
      errorDisplay.push(
        `Received To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.suspendedFromDate) {
      errorDisplay.push(
        `Suspended From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.suspendedToDate) {
      errorDisplay.push(
        `Suspended To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.batchFromDate) {
      errorDisplay.push(
        `Batch From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.batchToDate) {
      errorDisplay.push(
        `Batch To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.postToDate) {
      errorDisplay.push(
        `Postmarked To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (formErrors.postFromDate) {
      errorDisplay.push(
        `Postmarked From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
      );
    }
    if (
      values.checkFromDate !== '' &&
      values.checkToDate !== '' &&
      !formErrors.checkFromDate &&
      !formErrors.checkToDate
    ) {
      let frmDate = '';
      let toDate = '';
      frmDate = values.checkFromDate.includes('Q')
        ? convertQuaterFromDate(values.checkFromDate)
        : values.checkFromDate.length === 7
        ? convertFromDateToMMDDYYYY(values.checkFromDate)
        : values.checkFromDate;
      toDate = values.checkToDate.includes('Q')
        ? convertQuaterToDate(values.checkToDate)
        : values.checkToDate.length === 7
        ? convertToDateToMMDDYYYY(values.checkToDate)
        : values.checkToDate;
      const setError = compareTwoDates(frmDate, toDate)
        ? ''
        : errorDisplay.push(ErrorMessage.CHECK_START_DATE_GRETERTHAN_END_DATE);
      const setFieldError = compareTwoDates(frmDate, toDate)
        ? (formErr.checkGreaterDate = false)
        : (formErr.checkGreaterDate = true);
    } else formErr.checkGreaterDate = false;
    if (
      values.postFromDate !== '' &&
      values.postToDate !== '' &&
      !formErrors.postFromDate &&
      !formErrors.postToDate
    ) {
      let frmDate = '';
      let toDate = '';
      frmDate = values.postFromDate.includes('Q')
        ? convertQuaterFromDate(values.postFromDate)
        : values.postFromDate.length === 7
        ? convertFromDateToMMDDYYYY(values.postFromDate)
        : values.postFromDate;
      toDate = values.postToDate.includes('Q')
        ? convertQuaterToDate(values.postToDate)
        : values.postToDate.length === 7
        ? convertToDateToMMDDYYYY(values.postToDate)
        : values.postToDate;
      const setError = compareTwoDates(frmDate, toDate)
        ? ''
        : errorDisplay.push(ErrorMessage.POST_START_DATE_GRETERTHAN_END_DATE);
      const setFieldError = compareTwoDates(frmDate, toDate)
        ? (formErr.postGreaterDate = false)
        : (formErr.postGreaterDate = true);
    } else formErr.postGreaterDate = false;
    if (
      values.receivedFromDate !== '' &&
      values.receivedToDate !== '' &&
      !formErrors.receivedFromDate &&
      !formErrors.receivedToDate
    ) {
      let frmDate = '';
      let toDate = '';
      frmDate = values.receivedFromDate.includes('Q')
        ? convertQuaterFromDate(values.receivedFromDate)
        : values.receivedFromDate.length === 7
        ? convertFromDateToMMDDYYYY(values.receivedFromDate)
        : values.receivedFromDate;
      toDate = values.receivedToDate.includes('Q')
        ? convertQuaterToDate(values.receivedToDate)
        : values.receivedToDate.length === 7
        ? convertToDateToMMDDYYYY(values.receivedToDate)
        : values.receivedToDate;
      const setError = compareTwoDates(frmDate, toDate)
        ? ''
        : errorDisplay.push(ErrorMessage.REC_START_DATE_GRETERTHAN_END_DATE);
      const setFieldError = compareTwoDates(frmDate, toDate)
        ? (formErr.receivedGreaterDate = false)
        : (formErr.receivedGreaterDate = true);
    } else formErr.receivedGreaterDate = false;
    if (
      values.batchFromDate !== '' &&
      values.batchToDate !== '' &&
      !formErrors.batchFromDate &&
      !formErrors.batchToDate
    ) {
      let frmDate = '';
      let toDate = '';
      frmDate = values.batchFromDate.includes('Q')
        ? convertQuaterFromDate(values.batchFromDate)
        : values.batchFromDate.length === 7
        ? convertFromDateToMMDDYYYY(values.batchFromDate)
        : values.batchFromDate;
      toDate = values.batchToDate.includes('Q')
        ? convertQuaterToDate(values.batchToDate)
        : values.batchToDate.length === 7
        ? convertToDateToMMDDYYYY(values.batchToDate)
        : values.batchToDate;
      const setError = compareTwoDates(frmDate, toDate)
        ? ''
        : errorDisplay.push(ErrorMessage.BATCH_START_DATE_GRETERTHAN_END_DATE);
      const setFieldError = compareTwoDates(frmDate, toDate)
        ? (formErr.batchGreaterDate = false)
        : (formErr.batchGreaterDate = true);
    } else formErr.batchGreaterDate = false;
    if (
      values.suspendedFromDate !== '' &&
      values.suspendedToDate !== '' &&
      !formErrors.suspendedFromDate &&
      !formErrors.suspendedToDate
    ) {
      let frmDate = '';
      let toDate = '';
      frmDate = values.suspendedFromDate.includes('Q')
        ? convertQuaterFromDate(values.suspendedFromDate)
        : values.suspendedFromDate.length === 7
        ? convertFromDateToMMDDYYYY(values.suspendedFromDate)
        : values.suspendedFromDate;
      toDate = values.suspendedToDate.includes('Q')
        ? convertQuaterToDate(values.suspendedToDate)
        : values.suspendedToDate.length === 7
        ? convertToDateToMMDDYYYY(values.suspendedToDate)
        : values.suspendedToDate;
      const setError = compareTwoDates(frmDate, toDate)
        ? ''
        : errorDisplay.push(ErrorMessage.SUS_START_DATE_GRETERTHAN_END_DATE);
      const setFieldError = compareTwoDates(frmDate, toDate)
        ? (formErr.suspendedGreaterDate = false)
        : (formErr.suspendedGreaterDate = true);
    } else formErr.suspendedGreaterDate = false;
    setFormsError({ ...formErrors, ...formErr });
    setErrorMessages([...errorDisplay]);
    data = {
      ...checkSearchFormError,
      ...formErr,
    };
    dispatch(checkSearchFormErrorAction(data));
    dispatch(checkSearchErrorMessageAction(errorDisplay));
    if (errorDisplay.length > 0) {
      errorDisplay.forEach((item) => {
        if (item === ErrorMessage.ATLEAST_ONE_SEARCH_FIELD)
          window.scrollTo(0, 0);
        return '';
      });
      return false;
    }
    return true;
  };

  // On clicking on Search, this function will perform searchCheck service call.
  const onSearch = () => {
    let checkFrmDate = '';
    let checkTDate = '';
    let recFrmDate = '';
    let recTDate = '';
    let batchFrmDate = '';
    let batchTDate = '';
    let susFrmDate = '';
    let susTDate = '';
    let pstFrmDate = '';
    let pstTDate = '';
    setErrorMessages([]);
    const regexNumber = /^[0-9/]+$/;
    if (isValidation('Search')) {
      if (values.checkFromDate && values.checkFromDate.trim() !== '') {
        if (values.checkFromDate.includes('Q')) {
          checkFrmDate = convertQuaterFromDate(values.checkFromDate);
        } else if (
          regexNumber.test(values.checkFromDate) &&
          values.checkFromDate.includes('/') &&
          values.checkFromDate.length < 10
        ) {
          checkFrmDate = convertFromDateToMMDDYYYY(values.checkFromDate);
        } else if (
          regexNumber.test(values.checkFromDate) &&
          values.checkFromDate.includes('/') &&
          values.checkFromDate.length === 10
        ) {
          checkFrmDate = values.checkFromDate;
        }
      }
      
      // Received From Date
      if (values.receivedFromDate && values.receivedFromDate.trim() !== '') {
        if (values.receivedFromDate.includes('Q')) {
          recFrmDate = convertQuaterFromDate(values.receivedFromDate);
        } else if (
          regexNumber.test(values.receivedFromDate) &&
          values.receivedFromDate.includes('/') &&
          values.receivedFromDate.length < 10
        ) {
          recFrmDate = convertFromDateToMMDDYYYY(values.receivedFromDate);
        } else if (
          regexNumber.test(values.receivedFromDate) &&
          values.receivedFromDate.includes('/') &&
          values.receivedFromDate.length === 10
        ) {
          recFrmDate = values.receivedFromDate;
        }
      }
      
      // Batch From Date
      if (values.batchFromDate && values.batchFromDate.trim() !== '') {
        if (values.batchFromDate.includes('Q')) {
          batchFrmDate = convertQuaterFromDate(values.batchFromDate);
        } else if (
          regexNumber.test(values.batchFromDate) &&
          values.batchFromDate.includes('/') &&
          values.batchFromDate.length < 10
        ) {
          batchFrmDate = convertFromDateToMMDDYYYY(values.batchFromDate);
        } else if (
          regexNumber.test(values.batchFromDate) &&
          values.batchFromDate.includes('/') &&
          values.batchFromDate.length === 10
        ) {
          batchFrmDate = values.batchFromDate;
        }
      }
      
      // Suspended From Date
      if (values.suspendedFromDate && values.suspendedFromDate.trim() !== '') {
        if (values.suspendedFromDate.includes('Q')) {
          susFrmDate = convertQuaterFromDate(values.suspendedFromDate);
        } else if (
          regexNumber.test(values.suspendedFromDate) &&
          values.suspendedFromDate.includes('/') &&
          values.suspendedFromDate.length < 10
        ) {
          susFrmDate = convertFromDateToMMDDYYYY(values.suspendedFromDate);
        } else if (
          regexNumber.test(values.suspendedFromDate) &&
          values.suspendedFromDate.includes('/') &&
          values.suspendedFromDate.length === 10
        ) {
          susFrmDate = values.suspendedFromDate;
        }
      }
      
      // Post From Date
      if (values.postFromDate && values.postFromDate.trim() !== '') {
        if (values.postFromDate.includes('Q')) {
          pstFrmDate = convertQuaterFromDate(values.postFromDate);
        } else if (
          regexNumber.test(values.postFromDate) &&
          values.postFromDate.includes('/') &&
          values.postFromDate.length < 10
        ) {
          pstFrmDate = convertFromDateToMMDDYYYY(values.postFromDate);
        } else if (
          regexNumber.test(values.postFromDate) &&
          values.postFromDate.includes('/') &&
          values.postFromDate.length === 10
        ) {
          pstFrmDate = values.postFromDate;
        }
      }
      
      // Check To Date
      if (values.checkToDate && values.checkToDate.trim() !== '') {
        if (values.checkToDate.includes('Q')) {
          checkTDate = convertQuaterToDate(values.checkToDate);
        } else if (
          regexNumber.test(values.checkToDate) &&
          values.checkToDate.includes('/') &&
          values.checkToDate.length < 10
        ) {
          checkTDate = convertToDateToMMDDYYYY(values.checkToDate);
        } else if (
          regexNumber.test(values.checkToDate) &&
          values.checkToDate.includes('/') &&
          values.checkToDate.length === 10
        ) {
          checkTDate = values.checkToDate;
        }
      }
      
      // Received To Date
      if (values.receivedToDate && values.receivedToDate.trim() !== '') {
        if (values.receivedToDate.includes('Q')) {
          recTDate = convertQuaterToDate(values.receivedToDate);
        } else if (
          regexNumber.test(values.receivedToDate) &&
          values.receivedToDate.includes('/') &&
          values.receivedToDate.length < 10
        ) {
          recTDate = convertToDateToMMDDYYYY(values.receivedToDate);
        } else if (
          regexNumber.test(values.receivedToDate) &&
          values.receivedToDate.includes('/') &&
          values.receivedToDate.length === 10
        ) {
          recTDate = values.receivedToDate;
        }
      }
      
      // Batch To Date
      if (values.batchToDate && values.batchToDate.trim() !== '') {
        if (values.batchToDate.includes('Q')) {
          batchTDate = convertQuaterToDate(values.batchToDate);
        } else if (
          regexNumber.test(values.batchToDate) &&
          values.batchToDate.includes('/') &&
          values.batchToDate.length < 10
        ) {
          batchTDate = convertToDateToMMDDYYYY(values.batchToDate);
        } else if (
          regexNumber.test(values.batchToDate) &&
          values.batchToDate.includes('/') &&
          values.batchToDate.length === 10
        ) {
          batchTDate = values.batchToDate;
        }
      }
      
      // Suspended To Date
      if (values.suspendedToDate && values.suspendedToDate.trim() !== '') {
        if (values.suspendedToDate.includes('Q')) {
          susTDate = convertQuaterToDate(values.suspendedToDate);
        } else if (
          regexNumber.test(values.suspendedToDate) &&
          values.suspendedToDate.includes('/') &&
          values.suspendedToDate.length < 10
        ) {
          susTDate = convertToDateToMMDDYYYY(values.suspendedToDate);
        } else if (
          regexNumber.test(values.suspendedToDate) &&
          values.suspendedToDate.includes('/') &&
          values.suspendedToDate.length === 10
        ) {
          susTDate = values.suspendedToDate;
        }
      }
      
      // Post To Date
      if (values.postToDate && values.postToDate.trim() !== '') {
        if (values.postToDate.includes('Q')) {
          pstTDate = convertQuaterToDate(values.postToDate);
        } else if (
          regexNumber.test(values.postToDate) &&
          values.postToDate.includes('/') &&
          values.postToDate.length < 10
        ) {
          pstTDate = convertToDateToMMDDYYYY(values.postToDate);
        } else if (
          regexNumber.test(values.postToDate) &&
          values.postToDate.includes('/') &&
          values.postToDate.length === 10
        ) {
          pstTDate = values.postToDate;
        }
      }
      
      const newData = {
        checkLogNum: values.checkLogNum ? values.checkLogNum : null,
        batchNum: values.batchNum ? values.batchNum : null,
        checkNum: values.checkNum ? values.checkNum : null,
        disputeResolutionCd:
          values.disputeResolution !== '-1' ? values.disputeResolution : null,
        notDrugRebateInd:
          values.usedDrugRebate !== '-1'
            ? Number(values.usedDrugRebate) === 0
              ? 1
              : Number(values.usedDrugRebate) === 1
              ? 0
              : null
            : null,
        checkIdentifier: values.cnnNum ? values.cnnNum : null,
        checkPayeeCd: values.checkPayee !== '-1' ? values.checkPayee : null,
        lastUpdateUserId: values.LoggedUser !== '-1' ? values.LoggedUser : null,
        checkIssuer: values.checkIssuer ? values.checkIssuer : null,
        checkInfo: values.informationTxt ? values.informationTxt : null,
        paymentMediaTypeCd:
          values.paymentType !== '-1' ? values.paymentType : null,
        invRecFormatCd:
          values.invoiceReconcilication !== '-1'
            ? values.invoiceReconcilication
            : null,
        checkDt: checkFrmDate
          ? setDateFormatter(checkFrmDate)
          : values.checkFromDate && values.checkFromDate.trim() !== ''
          ? setDateFormatter(values.checkFromDate)
          : null,
        toCheckDt: checkTDate
          ? setDateFormatter(checkTDate)
          : values.checkToDate && values.checkToDate.trim() !== ''
          ? setDateFormatter(values.checkToDate)
          : null,
        suspendedDt: susFrmDate
          ? setDateFormatter(susFrmDate)
          : values.suspendedFromDate && values.suspendedFromDate.trim() !== ''
          ? setDateFormatter(values.suspendedFromDate)
          : null,
        toSuspendedDt: susTDate
          ? setDateFormatter(susTDate)
          : values.suspendedToDate && values.suspendedToDate.trim() !== ''
          ? setDateFormatter(values.suspendedToDate)
          : null,
        postmarkedDt: pstFrmDate
          ? setDateFormatter(pstFrmDate)
          : values.postFromDate && values.postFromDate.trim() !== ''
          ? setDateFormatter(values.postFromDate)
          : null,
        toPostmarkedDt: pstTDate
          ? setDateFormatter(pstTDate)
          : values.postToDate && values.postToDate.trim() !== ''
          ? setDateFormatter(values.postToDate)
          : null,
        batchDt: batchFrmDate
          ? setDateFormatter(batchFrmDate)
          : values.batchFromDate && values.batchFromDate.trim() !== ''
          ? setDateFormatter(values.batchFromDate)
          : null,
        toBatchDt: batchTDate
          ? setDateFormatter(batchTDate)
          : values.batchToDate && values.batchToDate.trim() !== ''
          ? setDateFormatter(values.batchToDate)
          : null,
        receivedDt: recFrmDate
          ? setDateFormatter(recFrmDate)
          : values.receivedFromDate && values.receivedFromDate.trim() !== ''
          ? setDateFormatter(values.receivedFromDate)
          : null,
        toReceivedDt: recTDate
          ? setDateFormatter(recTDate)
          : values.receivedToDate && values.receivedToDate.trim() !== ''
          ? setDateFormatter(values.receivedToDate)
          : null,
      };
      setOnSearch(true);
      setLoading(true);
      window.localStorage.setItem(
        'initialSearchValues',
        JSON.stringify(newData)
      );
      getAllSearchCheckResults(newData);
      setErrorMessages([]);
      window.sessionStorage.setItem('closeCheckTab', JSON.stringify(false));
    }
  };
  React.useEffect(() => {
    if (
      userDefaults &&
      userDefaults.checkPayeeCd &&
      (checkSearchRequest?.checkPayee === '' ||
        checkSearchRequest?.checkPayee === null ||
        checkSearchRequest?.checkPayee === undefined)
    ) {
      setValues({ ...values, checkPayee: userDefaults.checkPayeeCd });
    } else {
      setValues({ ...values, checkPayee: '-1' });
    }
  }, [userDefaults]);

  React.useEffect(() => {
    const getCloseCheckTab =
      JSON.parse(sessionStorage.getItem('closeCheckTab')) === null
        ? false
        : JSON.parse(sessionStorage.getItem('closeCheckTab'));
    window.sessionStorage.setItem('closeCheckTab', JSON.stringify(false));
    if (
      searchCheckFromDisplay &&
      checkSearchResults &&
      checkSearchResults.length > 0
    ) {
      setShowTable(false);
      dispatch(setDisplayCheckTableData(checkSearchResults));

      if (onSeachState) {
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));

        if (
          updateTabs.findIndex((item) => item.navTo === '/display-check') === -1
        ) {
          updateTabs.push({
            navTo: '/display-check',
            value: 'Display Check List',
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          dispatch(clearReduxForFilterAndSort('/display-check'));
        }

        setOnSearch(false);
        props.history.push({
          pathname: '/display-check',
        });
      }
    } else if (
      checkSearchResults &&
      checkSearchResults.length === 1 &&
      onSeachState &&
      !getCloseCheckTab
    ) {
      setSearchCheckResults(checkSearchResults);
      setOnSearch(false);
      dispatch(dispatchSaveCheckValues({}));
      window.localStorage.setItem(
        'checkSearchValues',
        JSON.stringify(checkSearchResults[0])
      );
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/maintain-check',
        value: 'Maintain Check',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      dispatch(clearReduxForFilterAndSort('/maintain-check'));

      props.history.push({
        pathname: '/maintain-check',
      });
    } else if (
      checkSearchResults &&
      checkSearchResults.length > 1 &&
      !getCloseCheckTab
      // && onSeachState
    ) {
      window.scrollTo(0, 2000);
      setShowTable(true);
      setSearchCheckResults(checkSearchResults);
      setOnSearch(false);
    } else if (
      onSeachState &&
      checkSearchResults &&
      checkSearchResults.length === 0 &&
      !getCloseCheckTab
    ) {
      setErrorMessages([
        'No checks were found matching the provided criteria.',
      ]);
      dispatch(
        checkSearchErrorMessageAction([
          'No checks were found matching the provided criteria.',
        ])
      );
      window.scrollTo(0, 0);
      setShowTable(false);
      setOnSearch(false);
      setSearchCheckResults(checkSearchResults);
    } else if (
      // onSeachState &&
      checkSearchResults &&
      checkSearchResults.error === 'API failed' &&
      !getCloseCheckTab
    ) {
      setErrorMessages([
        'There was an error processing the request. Please retry the transaction.',
      ]);
      setOnSearch(false);
      window.scrollTo(0, 0);
    }
    setLoading(false);
  }, [checkSearchResults]);

  const getIndexSelected = (indexSelected) => {
    // const getDetailRow = checkSearchResults.filter((item, index) => {
    //   if (indexSelected === index) {
    //     return item;
    //   }
    // });
    dispatch(maintainCheckReqAction({}));
    dispatch(maintainCheckErrorMessageAction([]));
    dispatch(maintainCheckFormErrorAction({}));
    dispatch(dispatchSaveCheckValues({}));
    window.localStorage.setItem(
      'checkSearchValues',
      JSON.stringify(indexSelected)
    );
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/maintain-check',
      value: 'Maintain Check',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    dispatch(clearReduxForFilterAndSort('/maintain-check'));

    props.history.push({
      pathname: '/maintain-check',
    });
  };
  React.useEffect(() => {
    searchgeneralsystemparameterDetail();
    getCommonDropdownList({
      codeDomainList: [
        'DISPUTE_RESOLUTION_CD',
        'CHECK_PAYEE_CD',
        'COLLECTION_MEDIUM_CD',
        'PAYMENT_MEDIA_TYPE_CD',
        'INV_REC_FORMAT_CD',
        'LAST_UPDATE_USER_ID',
      ],
    }).then((res) => {
      setCommonDropdownList(res);
    });
    getFetchAllLastUsers();
    if (checkSearchRequest && Object.keys(checkSearchRequest).length > 0) {
      setValues({
        checkLogNum: checkSearchRequest.checkLogNum || '',
        checkNum: checkSearchRequest.checkNum || '',
        batchNum: checkSearchRequest.batchNum || '',
        disputeResolution: checkSearchRequest.disputeResolution || '-1',
        usedDrugRebate:
          checkSearchRequest.usedDrugRebate !== undefined &&
          checkSearchRequest.usedDrugRebate !== null &&
          checkSearchRequest.usedDrugRebate !== ''
            ? String(checkSearchRequest.usedDrugRebate)
            : '1',
        cnnNum: checkSearchRequest.cnnNum || '',
        checkPayee:
          checkSearchRequest.checkPayee || userDefaults?.checkPayeeCd || '-1',
        LoggedUser: checkSearchRequest.LoggedUser || '-1',
        checkIssuer: checkSearchRequest.checkIssuer || '',
        informationTxt: checkSearchRequest.informationTxt || '',
        paymentType: checkSearchRequest.paymentType || '-1',
        invoiceReconcilication:
          checkSearchRequest.invoiceReconcilication || '-1',
        checkFromDate: checkSearchRequest.checkFromDate || '',
        checkToDate: checkSearchRequest.checkToDate || '',
        receivedFromDate: checkSearchRequest.receivedFromDate || '',
        receivedToDate: checkSearchRequest.receivedToDate || '',
        suspendedFromDate: checkSearchRequest.suspendedFromDate || '',
        suspendedToDate: checkSearchRequest.suspendedToDate || '',
        batchFromDate: checkSearchRequest.batchFromDate || '',
        batchToDate: checkSearchRequest.batchToDate || '',
        postFromDate: checkSearchRequest.postFromDate || '',
        postToDate: checkSearchRequest.postToDate || '',
      });
    }
    if (checkSearchFormError && Object.keys(checkSearchFormError).length > 0) {
      setFormsError({
        checkFromDate: checkSearchFormError.checkFromDate || false,
        checkGreaterDate: checkSearchFormError.checkGreaterDate || false,
        checkToDate: checkSearchFormError.checkToDate || false,
        receivedFromDate: checkSearchFormError.receivedFromDate || false,
        receivedGreaterDate: checkSearchFormError.receivedGreaterDate || false,
        receivedToDate: checkSearchFormError.receivedToDate || false,
        suspendedFromDate: checkSearchFormError.suspendedFromDate || false,
        suspendedGreaterDate:
          checkSearchFormError.suspendedGreaterDate || false,
        suspendedToDate: checkSearchFormError.suspendedToDate || false,
        batchFromDate: checkSearchFormError.batchFromDate || false,
        batchGreaterDate: checkSearchFormError.batchGreaterDate || false,
        batchToDate: checkSearchFormError.batchToDate || false,
        postFromDate: checkSearchFormError.postFromDate || false,
        postGreaterDate: checkSearchFormError.postGreaterDate || false,
        postToDate: checkSearchFormError.postToDate || false,
      });
    }
    if (
      checkSearchErrorMessage &&
      Object.keys(checkSearchErrorMessage).length > 0
    ) {
      setErrorMessages(checkSearchErrorMessage);
      if (checkSearchErrorMessage.length > 0) {
        checkSearchErrorMessage.forEach((item) => {
          if (item === ErrorMessage.ATLEAST_ONE_SEARCH_FIELD) {
            setShowTable(false);
            window.scrollTo(0, 0);
          }
        });
      }
    }
  }, []);
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      checkSearchErrorMessage &&
      Object.keys(checkSearchErrorMessage).length > 0
    ) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/check' || item.navTo === '/checks') {
            item.isFormError = true;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    } else {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/check' || item.navTo === '/checks') {
            item.isFormError = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [checkSearchErrorMessage]);
  React.useEffect(() => {
    if (getAllLastUserIds && getAllLastUserIds.length > 0) {
      setUserIdValueList(getAllLastUserIds);
    }
  }, [getAllLastUserIds]);

  React.useEffect(() => {
    if (payload && payload.length > 0) {
      if (payload[0].checkLogByCcnInd) {
        window.localStorage.setItem('checkLogByCCN', JSON.stringify(true));
        setDisableCCN(false);
      } else {
        window.localStorage.setItem('checkLogByCCN', JSON.stringify(false));
        setDisableCCN(true);
      }
      if (payload[0].checkLogUsesBatchInd === 1) {
        window.localStorage.setItem('checkLogBatchNum', JSON.stringify(true));
        setDisableBatch(false);
      } else {
        window.localStorage.setItem('checkLogBatchNum', JSON.stringify(false));
        setDisableBatch(true);
      }
    }
  }, [payload]);
  // on Reset Button click
  const handelCancel = () => {
    setCheckPayeeChanged(false);
    setShowTable(false);
    setValues({
      checkLogNum: '',
      checkNum: '',
      batchNum: '',
      disputeResolution: '-1',
      usedDrugRebate: '1',
      cnnNum: '',
      checkPayee:
        userDefaults && userDefaults.checkPayeeCd
          ? userDefaults.checkPayeeCd
          : '-1',
      LoggedUser: '-1',
      checkIssuer: '',
      informationTxt: '',
      paymentType: '-1',
      invoiceReconcilication: '-1',
      checkFromDate: '',
      checkToDate: '',
      receivedFromDate: '',
      receivedToDate: '',
      suspendedFromDate: '',
      suspendedToDate: '',
      batchFromDate: '',
      batchToDate: '',
      postFromDate: '',
      postToDate: '',
    });
    setFormsError({
      checkFromDate: false,
      checkGreaterDate: false,
      checkToDate: false,
      receivedFromDate: false,
      receivedGreaterDate: false,
      receivedToDate: false,
      suspendedFromDate: false,
      suspendedGreaterDate: false,
      suspendedToDate: false,
      batchFromDate: false,
      batchGreaterDate: false,
      batchToDate: false,
      postFromDate: false,
      postGreaterDate: false,
      postToDate: false,
    });
    setOpenCancel(false);
    setErrorMessages([]);
    setShowTable(false);
    const data = {};
    dispatch(searchCheckReqAction(data));
    dispatch(checkSearchFormErrorAction(data));
    dispatch(checkSearchErrorMessageAction([]));
  };
  const handelCancelClose = () => {
    setErrorMessages([]);
    setOpenCancel(false);
  };
  const resetData = () => {
    setOpenCancel(true);
  };
  // on Click full sceen View Parent
  const setFullScreenViewParent = () => {
    setFullScreenView(!fullScreenView);
  };
  return (
    <div
      className="tBillPanel tabs-container custom-check"
      data-testid="checkComponent"
    >
      <Spinner load={loading} />
      <Dialog
        open={openCancel}
        onClose={handelCancelClose}
        data-testid="handelCancelClose"
        className="multiGroupDialog custom-dialog-box dialog-420 popup-content-top-margin"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Cancel </span>
                <span className="float-right" onClick={handelCancelClose}>
                  <i className="fa fa-times-circle" aria-hidden="true" />
                </span>
                <div className="clearfix" />
              </div>
              <div className="text-center px-2">
                <DialogContentText style={{ color: 'black' }}>
                  There are unsaved changes. Do you want to continue?
                </DialogContentText>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper my-2">
              <Button
                onClick={handelCancel}
                className="btn btn-success btn-search mr-2"
                data-testid="handelCancel"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>

              <Button
                onClick={handelCancelClose}
                className="btn btn-cancel btn-primary"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                No
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      {!fullScreenView && (
        <div className="">
          {window.location.pathname === '/check' ? (
            <CustomSeparator parent1="Maintain" parent2="Search Check" />
          ) : (
            <CustomSeparator parent1="Display" parent2="Checks" />
          )}
          <DisplayErrorMessages
            errorMessages={
              errorMessages && errorMessages.length > 0
                ? [...new Set(errorMessages)]
                : []
            }
          />
          <div className="btn-wrapper my-3">
            <div className="float-right th-btnGroup">
              <Button
                className="btn btn-success btn-search"
                data-testid="searchBTN"
                onClick={onSearch}
              >
                <SVGComponent iconName="Icon-search" />
                Search
              </Button>
              <Button
                className="btn btn-cancel"
                data-testid="resetBTN"
                onClick={resetData}
                disabled={
                  values.checkLogNum === '' &&
                  values.checkNum === '' &&
                  values.batchNum === '' &&
                  values.disputeResolution === '-1' &&
                  values.usedDrugRebate === '1' &&
                  values.cnnNum === '' &&
                  checkPayeeChanged === false &&
                  values.LoggedUser === '-1' &&
                  values.checkIssuer === '' &&
                  values.informationTxt === '' &&
                  values.paymentType === '-1' &&
                  values.invoiceReconcilication === '-1' &&
                  values.checkFromDate === '' &&
                  values.checkToDate === '' &&
                  values.receivedFromDate === '' &&
                  values.receivedToDate === '' &&
                  values.suspendedFromDate === '' &&
                  values.suspendedToDate === '' &&
                  values.batchFromDate === '' &&
                  values.batchToDate === '' &&
                  values.postFromDate === '' &&
                  values.postToDate === ''
                }
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>

            <div className="clearfix" />
          </div>
          <div className="tab-body">
            <form autoComplete="off">
              <fieldset className="custom-fieldset">
                <legend>Check Log Information</legend>

                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <TextField
                      data-testid="check_log_number"
                      id="check_log_number"
                      label="Check Log Number"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxLength: 38 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.checkLogNum}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'checkLogNum');
                      }}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      data-testid="check_number"
                      id="check_number"
                      label="Check Number"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxLength: 20 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.checkNum}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'checkNum');
                      }}
                    />
                  </div>
                  {!disableBatch && (
                    <div className="mui-custom-form input-md">
                      <TextField
                        data-testid="batch_number"
                        id="batch_number"
                        label="Batch Number"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 50 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.batchNum}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'batchNum');
                        }}
                      />
                    </div>
                  )}

                  <div className="mui-custom-form with-select">
                    <TextField
                      data-testid="dispute_resolution"
                      id="dispute_resolution"
                      label="Dispute Resolution"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'dispute_resolution' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.disputeResolution}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'disputeResolution');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {commonDropdownList?.DISPUTE_RESOLUTION_CD?.length > 0 &&
                        commonDropdownList?.DISPUTE_RESOLUTION_CD.map(
                          (item, key) => {
                            return (
                              <MenuItem
                                key={key}
                                value={item.codeValueID.codeValue}
                                className="frr-logcheck-dropdown-item"
                              >
                                {item.codeValueID.codeValue} -{' '}
                                {item.shortDescription}
                              </MenuItem>
                            );
                          }
                        )}
                    </TextField>
                  </div>
                  <div className="mui-custom-form with-select">
                    <TextField
                      data-testid="used_drug_rebate"
                      id="used_drug_rebate"
                      label="Used in Drug Rebate"
                      fullWidth
                      select
                      inputProps={{ 'aria-label': 'used_drug_rebate',"id":"used_drug_rebate"}}
                      InputLabelProps={{ shrink: true }}
                      value={values.usedDrugRebate}
                      onChange={(e) => handleOnChangeEvent(e, 'usedDrugRebate')}
                    >
                      {Array.isArray(usedInDrug) &&
                        usedInDrug.map((item) => (
                          <MenuItem key={item.id} value={item.value} className="frr-logcheck-dropdown-item">
                            {item.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </div>
                  <div className="mui-custom-form  input-md">
                    <TextField
                      data-testid="ccn"
                      id="cnn"
                      label="CCN"
                      fullWidth
                      disabled={!!disableCCN}
                      placeholder=""
                      inputProps={{ maxLength: 40, id: 'cnn' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.cnnNum}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'cnnNum');
                      }}
                    />
                  </div>

                  <div className="mui-custom-form with-select">
                    <TextField
                      data-testid="check_payee"
                      id="check_payee"
                      label="Check Payee"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'check_payee' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.checkPayee}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'checkPayee');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {commonDropdownList?.CHECK_PAYEE_CD?.map((item, key) => {
                        return (
                          <MenuItem
                            key={key}
                            value={item.codeValueID.codeValue}
                            className="frr-logcheck-dropdown-item"
                          >
                            {item.codeValueID.codeValue} -{' '}
                            {item.shortDescription}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                  <div className="mui-custom-form with-select">
                    <TextField
                      data-testid="logged_user"
                      id="logged_user"
                      label="Logged By User"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'logged_user' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.LoggedUser}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'LoggedUser');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {userIdValueList && userIdValueList?.length > 0
                        ? userIdValueList.map((item, key) => {
                            return (
                              <MenuItem key={key} value={item.lastUpdateUserId} className="frr-logcheck-dropdown-item">
                                {item.lastUpdateUserId}{' '}
                                {item.firstUserName || item.lastUserName
                                  ? '-'
                                  : ''}{' '}
                                {item.firstUserName} {item.lastUserName}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="tab-body">
            <form autoComplete="off">
              <fieldset className="custom-fieldset ">
                <legend>Check Issuer Information</legend>

                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <TextField
                      data-testid="check_issuer"
                      id="check_issuer"
                      label="Check Issuer"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxLength: 255 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.checkIssuer}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'checkIssuer');
                      }}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      data-testid="information"
                      id="information"
                      label="Information"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxLength: 2000 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.informationTxt}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'informationTxt');
                      }}
                    />
                  </div>
                  <div className="mui-custom-form with-select">
                    <TextField
                      data-testid="pay_type"
                      id="pay_type"
                      label="Payment Type"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'pay_type' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.paymentType || '-1'}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'paymentType');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {commonDropdownList?.PAYMENT_MEDIA_TYPE_CD?.map(
                        (item, key) => {
                          return (
                            <MenuItem
                              key={key}
                              value={item.codeValueID.codeValue}
                              className="frr-logcheck-dropdown-item"
                            >
                              {item.codeValueID.codeValue} -{' '}
                              {item.shortDescription}
                            </MenuItem>
                          );
                        }
                      )}
                    </TextField>
                  </div>
                  <div className="mui-custom-form with-select">
                    <TextField
                      data-testid="invoice_reconciliation"
                      id="invoice_reconciliation"
                      label="Invoice Reconciliation Format"
                      fullWidth
                      select
                      placeholder=""
                      inputProps={{
                        maxLength: 11,
                        id: 'invoice_reconciliation',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.invoiceReconcilication || '-1'}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'invoiceReconcilication');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {commonDropdownList?.INV_REC_FORMAT_CD?.map(
                        (item, key) => {
                          return (
                            <MenuItem
                              key={key}
                              value={item.codeValueID.codeValue}
                              className="frr-logcheck-dropdown-item"
                            >
                              {item.codeValueID.codeValue} -{' '}
                              {item.shortDescription}
                            </MenuItem>
                          );
                        }
                      )}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="tab-body custom-search-dates frr-contrast-grey-label">
            <form autoComplete="off">
              <fieldset className="custom-fieldset ">
                <legend>Search Dates</legend>

                <div className="mx-3">
                  <div className="row">
                    <div className="col-sm-6 col-md-4 ">
                      <div className="heading">Check Date/Quarter</div>
                      <div
                        className="mui-zip-flex"
                        style={{ display: 'contents' }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                data-testid="check_From_Date"
                                className="mandate-fields"
                                id="checkFromDate"
                                label="From"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.checkFromDate}
                                onChange={(date) => {
                                  handleChangeDate(date, 'checkFromDate');
                                }}
                                helperText={
                                  formErrors.checkFromDate
                                    ? `Check From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.checkGreaterDate
                                    ? ErrorMessage.CHECK_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                error={
                                  formErrors.checkFromDate
                                    ? `Check From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.checkGreaterDate
                                    ? ErrorMessage.CHECK_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'checkFromDate');
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                data-testid="check_To_Date"
                                id="checkToDate"
                                label="To"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.checkToDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'checkToDate');
                                }}
                                helperText={
                                  formErrors.checkToDate
                                    ? `Check To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                error={
                                  formErrors.checkToDate
                                    ? `Check To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'checkToDate');
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-4 ">
                      <div className="heading">Received Date/Quarter</div>
                      <div
                        className="mui-zip-flex"
                        style={{ display: 'contents' }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                data-testid="receivedFromDate"
                                id="receivedFromDate"
                                label="From"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.receivedFromDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'receivedFromDate');
                                }}
                                helperText={
                                  formErrors.receivedFromDate
                                    ? `Received From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.receivedGreaterDate
                                    ? ErrorMessage.REC_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                error={
                                  formErrors.receivedFromDate
                                    ? `Received From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.receivedGreaterDate
                                    ? ErrorMessage.REC_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                onBlur={(date) => {
                                  handleBlurDate(date, 'receivedFromDate');
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                id="receivedToDate"
                                data-testid="receivedToDate"
                                label="To"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.receivedToDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'receivedToDate');
                                }}
                                helperText={
                                  formErrors.receivedToDate
                                    ? `Received To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                error={
                                  formErrors.receivedToDate
                                    ? `Received To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'receivedToDate');
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-4 ">
                      <div className="heading">Suspended Date/Quarter</div>
                      <div
                        className="mui-zip-flex"
                        style={{ display: 'contents' }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                id="suspendedFromDate"
                                data-testid="suspendedFromDate"
                                label="From"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.suspendedFromDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'suspendedFromDate');
                                }}
                                helperText={
                                  formErrors.suspendedFromDate
                                    ? `Suspended From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.suspendedGreaterDate
                                    ? ErrorMessage.SUS_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                error={
                                  formErrors.suspendedFromDate
                                    ? `Suspended From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.suspendedGreaterDate
                                    ? ErrorMessage.SUS_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'suspendedFromDate');
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                id="suspendedToDate"
                                data-testid="suspendedToDate"
                                label="To"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.suspendedToDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'suspendedToDate');
                                }}
                                helperText={
                                  formErrors.suspendedToDate
                                    ? `Suspended To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                error={
                                  formErrors.suspendedToDate
                                    ? `Suspended To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'suspendedToDate');
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    { !disableBatch && <div className="col-sm-6 col-md-4 ">
                      <div className="heading">Batch Date/Quarter</div>
                      <div
                        className="mui-zip-flex"
                        style={{ display: 'contents' }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                id="batchFromDate"
                                data-testid="batchFromDate"
                                label="From"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.batchFromDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'batchFromDate');
                                }}
                                helperText={
                                  formErrors.batchFromDate
                                    ? `Batch From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.batchGreaterDate
                                    ? ErrorMessage.BATCH_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                error={
                                  formErrors.batchFromDate
                                    ? `Batch From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.batchGreaterDate
                                    ? ErrorMessage.BATCH_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'batchFromDate');
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                id="batchToDate"
                                data-testid="batchToDate"
                                label="To"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.batchToDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'batchToDate');
                                }}
                                helperText={
                                  formErrors.batchToDate
                                    ? `Batch To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                error={
                                  formErrors.batchToDate
                                    ? `Batch To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'batchToDate');
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                      }
                    <div className="col-sm-6 col-md-4 ">
                      <div className="heading">Postmarked Date/Quarter</div>
                      <div
                        className="mui-zip-flex"
                        style={{ display: 'contents' }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                id="postFromDate"
                                data-testid="postFromDate"
                                label="From"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.postFromDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'postFromDate');
                                }}
                                helperText={
                                  formErrors.postFromDate
                                    ? `Postmarked From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.postGreaterDate
                                    ? ErrorMessage.POST_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                error={
                                  formErrors.postFromDate
                                    ? `Postmarked From Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : formErrors.postGreaterDate
                                    ? ErrorMessage.POST_START_DATE_GRETERTHAN_END_DATE
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'postFromDate');
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="mui-custom-textField input-md w-100">
                              <TextField
                                className="mandate-fields"
                                id="postToDate"
                                data-testid="postToDate"
                                label="To"
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 10 }}
                                value={values.postToDate}
                                onChange={(event) => {
                                  handleChangeDate(event, 'postToDate');
                                }}
                                helperText={
                                  formErrors.postToDate
                                    ? `Postmarked To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                error={
                                  formErrors.postToDate
                                    ? `Postmarked To Date-${ConstantMessageData.DATE_QTR_VALIDATION}`
                                    : null
                                }
                                onBlur={(event) => {
                                  handleBlurDate(event, 'postToDate');
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div
                        className="mui-zip-flex"
                        style={{ display: 'contents' }}
                      >
                        <div className="mui-custom-form with-select  override-width-95" />
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      )}
      <div className="panel pb-0">
        <div className="table-wrappers mb-3">
          {showTable ? (
            <CheckTable
              data-testid="checkTableIndex"
              searchResults={searchCheckListResults || []}
              setFullScreenView={setFullScreenViewParent}
              disableCCN={disableCCN}
              disableBatch={disableBatch}
              getIndexSelected={getIndexSelected}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};
export default withRouter(CheckSearch);
